import { constants, useServices, useTranslation } from 'cng-web-lib'

import TermsAndConditionsApiUrls from 'src/apiUrls/TermsAndConditionsApiUrls'
import React, { useRef, useState } from 'react'
import TermsAndConditionsKeys from 'src/constants/locale/key/TermsAndConditions'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment'
import pathMap from '../../paths/pathMap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AlertDialog from '../../components/aciacehighway/AlertDialog'
import { generatePath } from 'react-router'
import Table from 'src/components/aciacehighway/Table'
import _ from 'lodash'

const {
  filter: { BETWEEN, IN, LIKE }
} = constants

function TablePage(props) {
  const { history, showNotification } = props

  const [alertDialog, setAlertDialog] = useState({ open: false, termsAndConditions: null })
  const tableRef = useRef(null)
  const { setInactive } = useServices()
  const { translate } = useTranslation(Namespace.TERMS_AND_CONDITIONS)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let id = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.ID
    )
    let content = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.CONTENT
    )
    let versionNumber = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.VERSION_NUMBER
    )
    let createdBy = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.CREATED_BY
    )
    let createdDate = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.CREATED_DATE
    )
    let active = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.ACTIVE
    )    

    return {
      id,
      content,
      versionNumber,
      createdBy,
      createdDate,
      active,
    }
  }

  const columns = [
    {
      field: "content",
      title: translatedTextsObject.content,
      render: (data) => {
        if (data.content && data.content.length > 1000) {
          return data.content.substring(0, 1000) + "..."
        }
      }
    },
    {
      field: "versionNumber",
      title: translatedTextsObject.startDate,
    },
    {
      field: "createdBy",
      title: translatedTextsObject.createdBy,
    },    
    {
      field: "createdDate",
      title: translatedTextsObject.createdDate,
      render: (data) =>
          data.createdDate && moment.utc(data.createdDate).format('YYYY-MM-DD')
    },    
    {
      field: "active",
      title: translatedTextsObject.active,
      render: (data) => {
        if (data.active) {
          return 'Active'
        } else {
          return 'Inactive'
        }
      }
    }
  ]

  const filters = [
    {
      label: translatedTextsObject.content,
      type: 'textfield',
      name: 'content',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.versionNumber,
      type: 'textfield',
      name: 'versionNumber',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.active,
      type: 'checkbox',
      name: 'active',
      operatorType: IN,
      options: [
        {
          fullWidth: true,
          label: 'Active',
          value: 'true',
          filterValue: {
            value: 'true'
          }
        },
        {
          fullWidth: true,
          label: 'Inactive',
          value: 'false',
          filterValue: {
            value: 'false'
          }
        },
      ]
    },
  ]

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.TERMS_AND_CONDITIONS_ADD_VIEW)
            },
            label: 'Create Terms And Conditions'
          }
        ]}
        columns={columns}
        compact
        fetch={{ url: TermsAndConditionsApiUrls.GET }}
        filters={filters}
        sortConfig={{ type: 'column', defaultField: 'createdDate', defaultDirection: 'DESC' }}
        onRowClick={(rowData) =>
          history.push(
            generatePath(pathMap.TERMS_AND_CONDITIONS_EDIT_VIEW, { id: rowData.id })
          )
        }
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: 'Edit',
            onClick: (rowData) =>
              history.push(
                generatePath(pathMap.TERMS_AND_CONDITIONS_EDIT_VIEW, { id: rowData.id })
              )
          }
        ]}
        showNotification={showNotification}     
        persistSettings
        tableRef={tableRef}
      />  
    </>
  )
}

export default TablePage
